import Vue from 'vue'
import Router from 'vue-router'
// import homePage from '@/components/views/homePage'
// import aboutHZ from '@/components/views/aboutHZ'
// import hzly from '@/components/views/hzly'
// import hzyj from '@/components/views/hzyj'
// import hzcbw from '@/components/views/hzcbw'
// import detail from '@/components/views/detail'
// import lawyer from '@/components/views/lawyer'
// import lDetail from '@/components/views/lawyerDetail'
// import search from '@/components/views/search'
// import contact from '@/components/views/contactUs'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: () => import('@/components/views/homePage')
    },
    {
      path:'/about',
      name: 'about',
      component: () => import('@/components/views/aboutHZ')
    },
    {
      path:'/hzly',
      name: 'hzly',
      component: () => import('@/components/views/hzly')
    },
    {
      path:'/hzyj',
      name: 'hzyj',
      component: () => import('@/components/views/hzyj')
    },
    {
      path:'/hzcbw',
      name: 'hzcbw',
      component: () => import('@/components/views/hzcbw')
    },
    {
      path:'/detail',
      name: 'detail',
      component: () => import('@/components/views/detail')
    },
    {
      path:'/lawyer',
      name: 'lawyer',
      component: () => import('@/components/views/lawyer')
    },
    {
      path:'/lDetail',
      name: 'lDetail',
      component: () => import('@/components/views/lawyerDetail')
    },
    {
      path:'/search',
      name: 'search',
      component: () => import('@/components/views/search')
    },
    {
      path:'/contact',
      name: 'contact',
      component: () => import('@/components/views/contactUs')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js